// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-form {\n  margin: 0 26%;\n}\n\n#login-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n", "",{"version":3,"sources":["webpack://src/pages/Login/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".login-form {\n  margin: 0 26%;\n}\n\n#login-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
